import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import { useStylesLayout } from "../styles/Layout";

export default function NavBarSkeleton() {
  const classes = useStylesLayout();

  return (
    <AppBar className={classes.appBar} position="relative">
      <Toolbar variant="dense" />
    </AppBar>
  );
}
